import { Badge, Box, Flex, Text, TextArea, TextField } from "@radix-ui/themes";
import { CheckCircleIcon } from "lucide-react";
import { useOAuthForm } from "../../OAuthFormContext";

export function AppleP8Fields() {
  const {
    applePrivateKey,
    setApplePrivateKey,
    hasExistingApplePrivateKey,
    appleKeyId,
    setAppleKeyId,
    appleTeamId,
    setAppleTeamId,
  } = useOAuthForm();

  return (
    <>
      <Box>
        <Flex align="center" gap="2" mb="1">
          <Text size="2" weight="medium">
            .p8 private key (PEM)
          </Text>
          {hasExistingApplePrivateKey && (
            <Badge color="green" variant="soft" size="1">
              <CheckCircleIcon size={12} style={{ marginRight: 4 }} />
              Stored
            </Badge>
          )}
        </Flex>
        <TextArea
          value={applePrivateKey}
          onChange={(e) => setApplePrivateKey(e.target.value)}
          placeholder={
            hasExistingApplePrivateKey
              ? "Paste a new .p8 here to replace the stored key — leave blank to keep using it."
              : "-----BEGIN PRIVATE KEY-----\n…\n-----END PRIVATE KEY-----"
          }
          rows={6}
          style={{ fontFamily: "monospace", fontSize: 12 }}
        />
      </Box>
      <Flex gap="3" direction={{ initial: "column", sm: "row" }}>
        <Box style={{ flex: 1 }}>
          <Text size="2" weight="medium" mb="1">
            Key ID
          </Text>
          <TextField.Root
            value={appleKeyId}
            onChange={(e) => setAppleKeyId(e.target.value)}
            placeholder="ABC123DEF4"
          />
        </Box>
        <Box style={{ flex: 1 }}>
          <Text size="2" weight="medium" mb="1">
            Team ID
          </Text>
          <TextField.Root
            value={appleTeamId}
            onChange={(e) => setAppleTeamId(e.target.value)}
            placeholder="ABCD123456"
          />
        </Box>
      </Flex>
    </>
  );
}
